import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ICountry } from '../../models/ICountry';
import { S1DataService } from '../../services/s1data.service';
import { IFeasibilityCountReport } from '../../models/IFeasibilityCountReport';
import { environment } from '../../../environments/environment';
import { FezaDataService } from '../../services/fezadata.service';
import { IFeasibilityCountReportResult } from '../../models/IFeasibilityCountReportResult';

@Component({
    selector: 'feasibility-counts-report',
    templateUrl: './feasibility-counts-report.component.html',
    styleUrls: ['./feasibility-counts-report.component.css']
})
export class FeasibilityCountsReportComponent implements OnInit {

    reportData: IFeasibilityCountReport;
    countries: Observable<Array<ICountry>>;
    isError: boolean;
    testModeValues: Array<object>;
    intervals: Array<object>;
    result: IFeasibilityCountReportResult;

    constructor(private dataService: S1DataService, private fezaService: FezaDataService) {
        this.reportData = {
            intervalSinceCreateDate: 30,
            testMode: 0,
            referenceClient: "iQuote",
            countries: []
        };
        this.intervals = [
            { value: 0, name:"-"},
            { value: 1, name: " Last 1 day" },
            { value: 7, name: " Last 7 days" },
            { value: 30, name: " Last 1 month" },
            { value: 365, name: " Last 1 year" }
        ];
        this.testModeValues = [
            { value: 0, name: " No" },            
            { value: 1, name: " Yes" },
            { value: 2, name: " All" }
        ]
    }

    ngOnInit() {
        this.countries = this.dataService.getCountries();        
        this.isError = false;
        this.GetCounts();
    }

    GetCounts() {
        this.result = null;
        //console.log(this.reportData);
        let url = environment.fezeUrl + `/api/v1/Report/FeasibilityCountReport?intervalSinceCreateDate=${this.reportData.intervalSinceCreateDate}&testMode=${this.reportData.testMode}&referenceClient=${this.reportData.referenceClient}&countries=${this.reportData.countries.join(",")}`;
        this.fezaService.GetGreenFlagCounts(url).subscribe(info => {
          this.result = info;
          this.result.total = this.result.feasibleAutoNoOverride + this.result.feasibleAutoWithOverride + this.result.feasibleAfterOverride + this.result.notFeasible;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/feasibility-counts-report/feasibility-counts-report.component.ts